
  const {
      linkTypeMap,
      createClient: createClientOriginal,
      generateGraphqlOperation,
      assertSameVersion,
  } = require('@gqlts/runtime')
  var typeMap = linkTypeMap(require('./types.cjs'))

  var version = '3.2.19'
  assertSameVersion(version)

  module.exports.version = version

  module.exports.createClient = 
function(options) {
    options = options || {}
    var optionsCopy = {
      url: undefined,
      queryRoot: typeMap.Query,
      mutationRoot: typeMap.Mutation,
      subscriptionRoot: typeMap.Subscription,
    }
    for (var name in options) {
      optionsCopy[name] = options[name];
    }
    return createClientOriginal(optionsCopy)
}

  module.exports.enumv1IndustryExperienceType = {
  DeclaredIndustries: 'DeclaredIndustries',
  JobExperience: 'JobExperience',
  MissionRole: 'MissionRole',
  ProjectExperience: 'ProjectExperience',
  SuggestedJobExperience: 'SuggestedJobExperience',
  SuggestedProjectExperience: 'SuggestedProjectExperience'
}

module.exports.enumv1MissionApplicationInternalStatus = {
  Interviewing: 'Interviewing',
  New: 'New',
  NotAvailable: 'NotAvailable',
  ProbablyNot: 'ProbablyNot',
  Rejected: 'Rejected',
  ShortlistGood: 'ShortlistGood',
  ShortlistStrong: 'ShortlistStrong'
}

module.exports.enumv1SearchType = {
  hybrid: 'hybrid',
  semanticRaw: 'semanticRaw'
}

module.exports.enumv1SearchUserFilterApiKeywordSource = {
  adminNotes: 'adminNotes',
  applications: 'applications',
  email: 'email',
  evaluationFeedbackForms: 'evaluationFeedbackForms',
  evaluationTranscripts: 'evaluationTranscripts',
  experiencesJobs: 'experiencesJobs',
  experiencesProjects: 'experiencesProjects',
  interviewTranscripts: 'interviewTranscripts',
  name: 'name',
  profileAbout: 'profileAbout',
  profileSuggestionsJobs: 'profileSuggestionsJobs',
  profileSuggestionsProjects: 'profileSuggestionsProjects',
  proposalBlurbs: 'proposalBlurbs',
  resume: 'resume',
  timesheetSummaries: 'timesheetSummaries',
  username: 'username'
}

module.exports.enumv1SearchUserFilterApiManagementExperience = {
  largeAndAboveTeam: 'largeAndAboveTeam',
  mediumTeam: 'mediumTeam',
  none: 'none',
  smallTeam: 'smallTeam'
}

module.exports.enumv1SearchUserFilterApiRoleApplicationStatus = {
  exclusive: 'exclusive',
  interviewing: 'interviewing',
  notReviewed: 'notReviewed',
  notSelected: 'notSelected',
  opportunityToUpdate: 'opportunityToUpdate',
  proposed: 'proposed',
  shortlisted: 'shortlisted',
  unavailable: 'unavailable',
  waitlisted: 'waitlisted'
}

module.exports.enumv1UserBadge = {
  ATeamer: 'ATeamer',
  ATeamerResidence: 'ATeamerResidence',
  BeenOnMission: 'BeenOnMission',
  ExceptionalATeamer: 'ExceptionalATeamer',
  HighPotential: 'HighPotential',
  LimitedAccess: 'LimitedAccess',
  NotScrubbed: 'NotScrubbed',
  SelectionTeam: 'SelectionTeam',
  UnqualifiedUser: 'UnqualifiedUser',
  Unvetted: 'Unvetted',
  VettingInterviewDate: 'VettingInterviewDate',
  VettingScheduled: 'VettingScheduled'
}

module.exports.enumv1UserScrubbed = {
  Exceptional: 'Exceptional',
  Insufficient: 'Insufficient',
  LegacyUnknown: 'LegacyUnknown',
  Unknown: 'Unknown',
  Verified: 'Verified'
}

module.exports.enumv1UserStatus = {
  Active: 'Active',
  ActiveWaitlisted: 'ActiveWaitlisted',
  Deleted: 'Deleted',
  Registered: 'Registered',
  Rejected: 'Rejected'
}

module.exports.enumv1UserType = {
  companyUser: 'companyUser',
  user: 'user'
}


  module.exports.generateQueryOp = function(fields) {
    return generateGraphqlOperation('query', typeMap.Query, fields)
  }
  module.exports.generateMutationOp = function(fields) {
    return generateGraphqlOperation('mutation', typeMap.Mutation, fields)
  }
  module.exports.generateSubscriptionOp = function(fields) {
    return generateGraphqlOperation('subscription', typeMap.Subscription, fields)
  }
  module.exports.everything = {
    __scalar: true
  }

  var schemaExports = require('./guards.cjs')
  for (var k in schemaExports) {
    module.exports[k] = schemaExports[k];
  }
  